import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteSocialLinkDataAsync, saveSocialLinkDataAsync } from "../../utils/customer/socialLinkSlice";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchSocialCategoryQuery,
  useUpdateCustomerSocialLinkDataMutation,
} from "../../utils/customer/customerSelect";
import {
  useFetchCustomerSocialDataQuery,
  useUpdateCustomerSocialDataMutation,
} from "../../utils/customer/customerTaskTable";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { pushAlert } from "../../utils/alertSlice";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { ReactComponent as LinkIcon } from "../../assets/images/icons/linkIcon.svg";
import Social_LinkedInIcon from "../../assets/images/icons/Social_LinkedInIcon.svg";
import Social_FaceBookIcon from "../../assets/images/icons/Social_FaceBookIcon.svg";
import Social_TwitterIcon from "../../assets/images/icons/Social_TwitterIcon.svg";
import Social_InstagramIcon from "../../assets/images/icons/Social_InstagramIcon.svg";
import Social_OtherIcon from "../../assets/images/icons/Social_OtherIcon.svg";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import { useCustomerEditMutation } from "../../utils/customer/customerTable";
import { ReactComponent as Emptylink } from "../../assets/images/icons/emptylink.svg";

const validationRules = {
  link_type: {
    required: true,
    errorMessage: "Link Type is required.",
  },
  link: {
    required: true,
    errorMessage: "Social Link is required.",
    link: true,
  },
};

const CustomerSocialModel = ({
  onClose,
  isEditMode,
  setIsEditMode,
  handleDelete,
  onSave,
  isAddMode,
  setIsAddMode,
  customerSocialData,
  addCustomerId,
  setRefetchAllData,
  EmptyMessage,
  handleCancel,
}) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [customerTablePagination, setCustomerTablePagination] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [updateCustomerSocialLinkData] = useUpdateCustomerSocialLinkDataMutation();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isExpanded, setIsExpanded] = useState(null);

  const closeoutsideclick = useClickOutside(() => {
    // onClose();
  });

  const { id } = useParams();
  const customerId = parseInt(id);
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const companyLocalData = localStorage.getItem("company_data");

  const [formErrors, setFormErrors] = useState({
    link_type: "",
    link: "",
  });
  const [formData, setFormData] = useState({
    link_type: "",
    link: "",
    id: "",
  });

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleFieldChange = (e) => {
    handleChange(e);

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [customerEditMutation] = useCustomerEditMutation();

  const handleSave = async (event) => {
    event.preventDefault();
    const formValid = isFormValid();

    console.log("formValid val", formValid);
    if (!formValid) {
      return;
    }

    const socialData = {
      recordType: "social_link",
      id: formData.id ? formData.id : "",
      customer_id: addCustomerId ? addCustomerId : customerId,
      social_link_id: event.target.link_type.value,
      link: "",
      social_link: event.target.link.value,
    };
    onSave(socialData);
  };

  const { data: customerSocialCategory, refetch: refetchCustomerData } = useFetchSocialCategoryQuery({ token });

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };
  useEffect(() => {
    const handleEscKeyPress = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEscKeyPress);
    };
  }, [onClose]);

  // const handleCancelButtonClick = () => {
  //   setIsEditMode(false);
  //   setIsAddMode(false);
  // };

  const handleEdit = (id, rowData) => {
    setIsEditMode(true);
    setEditData(rowData);

    setFormData({
      id: rowData?.id,
      link_type: rowData?.social_type,
      link: rowData?.links,
    });
  };

  useEffect(() => {
    if (isAddMode) {
      setEditData(null);
      setFormData({
        id: "",
        link_type: "",
        link: "",
      });
    }
  }, [isAddMode]);

  // useEffect(() => {
  //   fetchData();
  // }, [addCustomerId]);

  const handleDeleteSocial = async (data) => {
    const payload = {
      recordType: "social_link",
      rid: data?.id,
      cid: addCustomerId ? addCustomerId : Number(customerId),
    };
    handleDelete(payload, data?.links);
  };

  function convertSocials(data) {
    return data.map((item) => {
      return {
        id: item.id,
        social_type: item.social_link_id,
        links: item.social_link,
      };
    });
  }

  useEffect(() => {
    if (true) {
      setCustomer(convertSocials(customerSocialData || []));
    }
  }, [customerSocialData]);

  const SocialLinkIcon = ({ type }) => {
    const SocialLinkIcons = {
      Facebook: Social_FaceBookIcon,
      Linkedin: Social_LinkedInIcon,
      Instagram: Social_InstagramIcon,
      Twitter: Social_TwitterIcon,
      Other: Social_OtherIcon,
    };

    if (SocialLinkIcons[type]) return <img src={SocialLinkIcons[type]} alt="Social Linktype" />;
    return <img src={Social_OtherIcon} alt="Other Icon" />;
  };

  const charLimit = 25;
  const truncateText = (text, charLimit) => {
    if (text.length > charLimit) {
      return text.substring(0, charLimit) + "...";
    }
    return text;
  };

  return (
    <div className="relative bg-white font-popns flex flex-col w-full  h-full" ref={closeoutsideclick}>
      {/* <h3 className="text-16 font-500 text-434852 py-2 px-3">
        {isAddMode ? "Add Links" : isEditMode ? "Edit Links" : "View Links"}
      </h3> */}

      {isEditMode ? (
        <>
          <form onSubmit={handleSave} className="grow min-h-0 flex flex-col justify-between gap-5 pt-3 pb-5 mt-3">
            <div className="space-y-3 px-3">
              <div>
                <label htmlFor="link_type" className="block text-14 font-400 text-434852">
                  Link Type <span className="text-red-500">*</span>
                  {errors.link_type && <span className="text-red-700"> {errors.link_type}</span>}
                </label>
                <select
                  id="link_type"
                  name="link_type"
                  value={formData.link_type}
                  onChange={handleFieldChange}
                  onBlur={handleBlur}
                  className={`form-select border py-0 text-434852 text-12 font-400 bg-white rounded  border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full`}
                >
                  <option hidden>Select Link Type</option>
                  {!customerSocialCategory?.data
                    ? null
                    : customerSocialCategory?.data?.map((CategoryData) => (
                        <option key={CategoryData?.name} value={CategoryData?.name}>
                          {CategoryData?.name}
                        </option>
                      ))}
                </select>
              </div>

              <div>
                <label htmlFor="link" className="block text-14 font-400 text-434852">
                  Social Links <span className="text-red-500">*</span>
                  {errors && <span className="text-red-700"> {errors.link}</span>}
                </label>
                <input
                  placeholder="Enter Social Link"
                  type="text"
                  id="link"
                  name="link"
                  // pattern="https?://(www\.)?(facebook\.com|linkedin\.com)/.*"
                  pattern="((https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?)"
                  value={formData.link}
                  onChange={handleFieldChange}
                  className="bg-white border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-xs block w-full p-3 rounded text-434852 text-12 font-400"
                />
                {formErrors.link && <span className="text-red-500 text-xs">Cannot be left blank.</span>}
              </div>
            </div>

            <div className="flex justify-end text-md w-full border-t border-BECBD3 pt-3 px-3">
              <button
                onClick={handleCancel}
                type="button"
                className="px-6 py-1 text-16 rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2"
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="px-6 py-1 text-16 rounded-5px font-500 bg-1D4469 text-white focus:outline-none cbtn-transition-bg cbtn-transition-bg"
              >
                SAVE
              </button>
            </div>
          </form>
        </>
      ) : (
        <div className={`flex flex-col grow min-h-0 gap-4 overflow-y-auto`}>
          {customer.length ? (
            customer.map((data, index) => {
              return (
                <>
                  <div className="border-b rounded-md group">
                    <div
                      className="relative transition-all duration-300 "
                      onMouseEnter={() => setHoveredIndex(data.id)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div className={`${hoveredIndex === data.id ? "bg-[#F1F6F9]" : "bg-white"} p-4`}>
                        <div className="flex flex-col gap-3 ">
                          <div className="flex gap-1.5">
                            <span className="self-center">
                              <SocialLinkIcon type={data.social_type ? data.social_type : "Other"} />
                            </span>
                            <span className="text-2C495D font-400 text-sm ">
                              {data.social_type ? data.social_type : "--"}{" "}
                            </span>
                          </div>
                          <div className="flex gap-1.5 items-center group ">
                            <span className="self-center">
                              <LinkIcon />
                            </span>
                            {/* <span className="text-2C495D font-400 text-sm">{data.links ? data.links : "--"}</span> */}
                            <span
                              className="text-[#2C495D] font-[400] text-sm cursor-pointer"
                              onClick={() => setIsExpanded(isExpanded === index ? null : index)}
                            >
                              {isExpanded === index ? data.links || "--" : truncateText(data.links || "--", charLimit)}
                            </span>
                            <div className="invisible group-hover:visible ml-2">
                              <CopyIconComponent copyValue={data?.links} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="absolute right-1 bottom-1 group/edit1">
                        <div
                          className={`flex justify-end me-4 gap-4 transition-opacity items-center opacity-0 group-hover:opacity-100`}
                        >
                          <button onClick={() => handleEdit(data.id, data)}>
                            <i className="bi bi-pencil-fill text-[#969BA9] font-500"></i>
                          </button>
                          <button onClick={() => handleDeleteSocial(data)}>
                            <i className="bi bi-trash-fill text-[#F84545] font-500"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <>
              <EmptyMessage Icon={Emptylink} Message={"No social link is available."} ButtonText={"Add Social Link"} />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerSocialModel;
